import { useSchemaViewerFormContext } from "./schema-viewer-form.context";
import { extractSchemaLabels } from "./schema-viewer-form.helper";

/**
 * If it is reused in multiple places, we should move this in the context
 */
export const useSchemaViewerFormLabels = () => {
  const { schema } = useSchemaViewerFormContext();

  return { schemaFormLabels: extractSchemaLabels(schema) };
};
